import { getProfile, minecraftAuth, UserInfo } from "./auth";
import { epoxyFetch, initWisp } from "./connection/epoxy";
import { makeFakeWebSocket } from "./connection/fakewebsocket";

//@ts-expect-error this gets filled in by rollup
export const VERSION = self.VERSION;
//@ts-expect-error this too
export const COMMITHASH = self.COMMITHASH;

export let wispUrl: string;

export type ProxyMode = "none" | "auto" | "wisp";

export let proxyMode: ProxyMode = "none";

export function setProxyMode(mode: ProxyMode) {
	proxyMode = mode;
	localStorage["wispcraft_proxymode"] = mode;
}

export type AuthStore = {
	user: UserInfo | null;
	yggToken: string;
	msToken: string;
};

export type TokenStore = {
	username: string;
	token: string;
	ms: string;
};

export let authstore: AuthStore = {
	user: null,
	yggToken: "",
	msToken: "",
};

const nativeFetch = fetch;

export function setWispUrl(wisp: string) {
	const wispUrlUrl = new URL(wisp);
	if (!wispUrlUrl.pathname.endsWith("/")) {
		wispUrlUrl.pathname += "/";
	}
	wispUrl = wispUrlUrl.href;
}

wispUrl =
	((window as any).anura && (window as any).anura.wsproxyURL) ||
	new URL(window.location.href).searchParams.get("wisp") ||
	localStorage["wispcraft_wispurl"] ||
	"wss://anura.pro/";

// Initialize proxy mode from localStorage
if (localStorage["wispcraft_proxymode"]) {
	proxyMode = localStorage["wispcraft_proxymode"] as ProxyMode;
} else {
	proxyMode = "none";
	localStorage["wispcraft_proxymode"] = "none";
}

try {
	setWispUrl(wispUrl);
} catch (e) {
	console.error(e);
}

if (localStorage["wispcraft_accounts"]) {
	const accounts = JSON.parse(
		localStorage["wispcraft_accounts"]
	) as TokenStore[];
	const account = accounts.find(
		(account) =>
			account.username === localStorage["wispcraft_last_used_account"]
	);
	if (account) {
		(async () => {
			try {
				authstore.msToken = account.ms;
				authstore.yggToken = account.token;
				authstore.user = await getProfile(authstore.yggToken);
			} catch (e) {
				authstore.yggToken = await minecraftAuth(authstore.msToken);
				authstore.user = await getProfile(authstore.yggToken);
			}
		})();
	}
}

// replace websocket with our own
window.WebSocket = makeFakeWebSocket();

// eagler will fetch texture packs, will fail if cors isn't set
// should really fix this but whatever
window.fetch = async function (url: RequestInfo | URL, init?: RequestInit) {
	// If proxy mode is none, always use native fetch
	if (proxyMode === "none") {
		return await nativeFetch(url, init);
	}
	
	// If proxy mode is wisp, always use epoxy
	if (proxyMode === "wisp") {
		return await epoxyFetch("" + url, init);
	}
	
	// If proxy mode is auto, try native first, then fallback to epoxy
	try {
		return await nativeFetch(url, init);
	} catch (e) {
		return await epoxyFetch("" + url, init);
	}
};

type EaglerXOptions = any;
let eagoptions: EaglerXOptions;
// append settings to the server list
const settings = { addr: "settings://", name: "Wispcraft Settings" };
Object.defineProperty(window, "eaglercraftXOpts", {
	get() {
		if (eagoptions) {
			return eagoptions;
		}
		return { servers: [settings] };
	},
	set(v) {
		eagoptions = v;
		if (eagoptions?.servers) {
			eagoptions.servers.unshift(settings);
		} else {
			eagoptions.servers = [settings];
		}
	},
});

initWisp(wispUrl);

if (window["anura"]) {
	document.addEventListener("click", function () {
		setTimeout(function () {
			(window.frameElement as HTMLIFrameElement)?.focus();
			window.focus();
		}, 5);
	});
	(window.frameElement as HTMLIFrameElement)?.focus();
}
